import React from 'react';

import { IntegrationsConnection } from '@shipstation/connections-ui';
import PropTypes from 'prop-types';

import { useCommonCuiProps } from './helpers/use-common-cui-props';

export const CuiIntegrationsConnection = ({ integrationAppId }) => {
  const commonCuiProps = useCommonCuiProps();
  return <IntegrationsConnection {...commonCuiProps} integrationAppId={integrationAppId} />;
};

CuiIntegrationsConnection.propTypes = {
  integrationAppId: PropTypes.number.isRequired,
};
